import axios from 'axios';
import { toLower } from 'ramda';

import { mapObjectKeys } from './ramdaAdditions';
import ERRORS from '../constants/errors';

class HttpError {
    constructor(error) {
        const { response = {} } = error;

        this.origin = error;

        this.headers = mapObjectKeys(toLower, response.headers);
        this.data = response.data;
        this.status = response.status;
        this.code = parseInt(this.headers['x-error-code'], 10) || 'unknown';
        this.session = this.headers['x-error-session'];
        this.message = ERRORS[this.code];
    }
}

const errorHandler = (error) => {
    const httpError = new HttpError(error);
    return Promise.reject(httpError);
};

export function provideRequestInterceptors() {
    axios.interceptors.request.use(
        config => config,
        errorHandler
    );
}

export function provideResponseInterceptors() {
    axios.interceptors.response.use(
        response => response.data,
        errorHandler
    );
}
